import { useCallback } from "react";
import { useCloudContext, useConfigContext } from "@WahooFitness/wahoo-offline-mfe";
import { AuthTokens } from "@WahooFitness/cloud-client-ts";
import { AuthTokensType } from "@WahooFitness/cloud-client-types";

function useAuthTokenClient() {
  const { getCloudClient } = useCloudContext();
  const { wahooToken, fitnessAppId } = useConfigContext();
  const authTokenClient = getCloudClient(AuthTokens);

  const getAuthTokens = useCallback(async (): Promise<AuthTokensType> => {
    try {
      return await authTokenClient.post(wahooToken, fitnessAppId);
    } catch (err) {
      throw new Error("Error getting auth tokens");
    }
  }, [authTokenClient, fitnessAppId, wahooToken]);

  return { getAuthTokens };
}

export default useAuthTokenClient;
